import {SignInForm} from 'components/template/SignInForm'
import {observer} from 'mobx-react'

export const SignIn = observer(() => {
  return (
    <div className="text-gray-800 flex flex-col justify-center items-center">
      <SignInForm />
    </div>
  )
})
